import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  onAuthStateChanged,
  signInWithRedirect,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
  getRedirectResult,
} from 'firebase/auth';
import { auth } from '../firebase';

function AuthLoading() {
  const navigate = useNavigate();

  useEffect(() => {
    let finished = false;

    const startGoogleRedirect = async () => {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });

  await setPersistence(auth, browserLocalPersistence);
  sessionStorage.setItem('eascode_auth_redirect_started', '1');
  await signInWithRedirect(auth, provider);
};

    const goHome = (user) => {
      if (!user || finished) return;
      finished = true;
      sessionStorage.removeItem('eascode_auth_redirect_started');
      const storedRedirect = sessionStorage.getItem('eascode_post_login_redirect');
      sessionStorage.removeItem('eascode_post_login_redirect');
      const redirectTo =
        storedRedirect && storedRedirect.startsWith('/') && !storedRedirect.startsWith('//')
          ? storedRedirect
          : '/Old_Home';

      navigate(redirectTo, {
        state: { persona: 'parent' },
        replace: true,
      });
    };

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      goHome(user);
    });

    const run = async () => {
      try {

        await setPersistence(auth, browserLocalPersistence);
        const result = await getRedirectResult(auth);
        //console.log("redirect started:", sessionStorage.getItem('eascode_auth_redirect_started'));

        if (result?.user) {
          goHome(result.user);
          return;
        }

        if (auth.currentUser) {
          goHome(auth.currentUser);
          return;
        }

const alreadyStarted =
  sessionStorage.getItem('eascode_auth_redirect_started') === '1';

if (!alreadyStarted) {
  await startGoogleRedirect();
  return;
}

console.error('Google redirect returned without Firebase user.');
sessionStorage.removeItem('eascode_auth_redirect_started');
navigate('/login', { replace: true });
return;

      } catch (error) {
        console.error('Auth loading error:', error);
      }
    };

    run();

    return () => unsubscribe();
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f8fafc, #e0f2fe)',
      fontFamily: 'Inter, Arial, sans-serif',
      color: '#0f172a'
    }}>
      <div style={{
        width: 64,
        height: 64,
        border: '6px solid #bfdbfe',
        borderTopColor: '#2563eb',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }} />
      <h2 style={{ marginTop: 24, fontSize: 24 }}>Logging you in</h2>
      <p style={{ marginTop: 8, color: '#475569' }}>Preparing your Eascode workspace...</p>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default AuthLoading;
